import { Moment } from "moment";

export interface INotification {
    locator: string;
    message_type: string;
    type: string;
    initiator_locator?: string;
    receiver_locator: string;
    navigation_locator: string;
    message: string;
    created_at: Moment;
    createdAt: Moment;
    read: boolean;
    read_at: Moment;
}

export const NotificationType = {
    JobApplication: 'job_application', 
    UpcomingPayment: 'upcoming_payment', 
    Message: 'message', 
    ApplicationAccepted: 'application_accepted',
    ApplicationDeclined: 'application_declined',
    ApplicationInvite: 'application_invite',
    JobComplete: 'job_complete',
    JobReady: 'job_ready',
    NewReview: 'new_review',
}
